import {all, put, takeLatest} from 'redux-saga/effects';

import {HIDE_OVERLAY, hideOverlayAction} from 'actions/uiStateActions';

function* hideOverlay() {
  yield put(hideOverlayAction());
}

export default function* uiStateSaga() {
  yield all([takeLatest(HIDE_OVERLAY, hideOverlay)]);
}
